module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-5"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "ch-t"
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v("n May 1898, the American Congress authorized the construction of sixteen destroyers. Before America’s official entry into the First World War, the US Navy procured sixty-three destroyers divided into nine different classes. The last five classes were collectively referred to as ‘broken-deckers’ due to their high forecastle or ‘thousand-tonners’ due to their displacement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Keenly aware of the threat posed by the German U-boats in the First World War, the American Congress authorized 267 destroyers. Only forty-one entered service before that conflict concluded. The remainder were completed by 1922. Due to the majority having four smoke stacks, they received the nickname ‘four-stackers’ or ‘four-pipers’.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Beginning in 1932, up until the Japanese attack on Pearl Harbor, the US Navy placed into service ten new classes of destroyers totalling 169 units. During the war years, American shipyards built 334 destroyers, divided into three classes. The most numerous were the 175 examples of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fletcher")]), _vm._v(" class: the most successful destroyer design of the Second World War.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During the Cold War, the threat from the Soviet Navy’s submarine fleet pushed the development of seven new destroyer designs into service between 1949 and 1988, beginning with the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mitscher")]), _vm._v(" class and eventually into the stealth-shaped "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arleigh Burke")]), _vm._v(" class of which eighty-two units are planned. The intended replacement for the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arleigh Burke")]), _vm._v(" class by 2020 was to be the first of thirty-two examples of the futuristiclooking "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Zumwalt")]), _vm._v(" class. However, cost overrides led to the class’s cancellation in 2009 with only three to be built.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-414d31e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/005_Introduction.vue
// module id = 69
// module chunks = 0